import { dropDownArrowWhite, multiLayerIcon } from "../../../app/icons";
import styled from "styled-components";

export const StyledChangeBodyContainer = styled.div`
    margin: 164px 0 0 0;
    padding: 0px;
`;

export const StyledChangeTenantMultipleContainer = styled.div`
    width: 990px;
    background-color: #00acce;
    padding: 10px;
    margin: 0px auto;
    border-radius: 5px;
    zoom: 1;
`;

export const StyledMenuItemsLogin = styled.div`
    color: #b2dbfb;
    font-size: 12px;
    font-weight: normal;
    text-align: right;
    margin: 5px 12px 15px;
    text-shadow: none;
`;

export const StyledContact = styled.a`
    color: #ffffff;
    &:hover {
        text-decoration: underline;
    }
`;

export const StyledChangeTenantMultiWrapper = styled.div`
    padding: 80px 0 210px 70px;
    width: 100%;
`;

export const StyledMultiLayerIcon = styled.div`
    background: url(${multiLayerIcon}) no-repeat;
    width: 12%;
    height: 100px;
    float: left;
`;

export const StyledMultipleDropDown = styled.div`
    float: left;
    margin-left: 40px;
    width: 83%;
`;

export const StyledSelectAccountTitle = styled.div`
    font-size: 16px;
    color: #ffffff;
    text-align: left;
    margin-bottom: 22px;
`;

export const StyledSelectDropDown = styled.div``;

export const StyledSelectDropDownWrapper = styled.div`
    float: left !important;
    position: relative;
`;

export const StyledDropDownButton = styled.button`
    color: #afafaf;
    font-size: 12px;
    padding: 0 0 0 10px !important;
    text-align: left;
    height: 40px !important;
    width: 508px !important;
    background-color: transparent !important;
    border: 2px solid #b2dbfb !important;
    padding-left: ;
    border-radius: 0px !important;
    margin-bottom: 0;
    font-weight: 400;
    line-height: 1.42857143;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    display: inline-block;
    user-select: none;
    background-image: none;
`;

export const StyledContinueButtonWrapper = styled.div`
    float: left !important;
`;

export const StyledContinueButton = styled.div`
    background: #ffffff none repeat scroll 0 0;
    border: medium none;
    border-radius: 2px;
    color: #00acce;
    font-size: 14px;
    margin-left: 25px;
    padding: 10px 42px;
    float: left;
    font-family: inherit;
    line-height: inherit;
    height: 40px;
    width: 182px;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;

    &:hover {
        box-shadow: 3px 7px 13px 0 rgba(0, 0, 0, 0.15);
    }
`;

export const StyledCustomMultipleDropDown = styled.div`
    width: 508px !important;
    padding: 0px;
    margin: 0;
    font-size: 12px;
    min-height: 0;
    max-height: 194px;
    word-wrap: break-word;
    border: 0px;
    z-index: 9;
    cursor: inherit !important;
    border-radius: 0px 0px 2px 2px;
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    float: left;
    min-width: 160px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
`;

export const StyledValueSpan = styled.span`
    color: #ffffff;
    font-size: 14px;
    float: left;
    vertical-align: middle;
    line-height: 11px;
`;

export const StyledCaretSpan = styled.span`
    background: rgba(0, 0, 0, 0) url(${dropDownArrowWhite}) no-repeat scroll 0 3px;
    opacity: 1;
    border: 0px none;
    height: 12px;
    width: 11px;
    margin: 1px 9px 0 0;
    float: right;
`;

export const StyledClearBoth = styled.div`
    clear: both;
`;

export const StyledMultoDropUl = styled.ul`
    padding: 0px !important;
    margin: 0px;
    font-size: 12px;
    min-height: 0;
    max-height: 159px;
    overflow: auto;
    list-style: none;
    border-radius: 0px 0px 2px 2px;
`;

export const StyledTenantCodeList = styled.li`
    font-size: 14px;
    cursor: pointer;
    list-style: outside none none;
    padding-bottom: 12px;
    padding-left: 12px;
    padding-top: 12px;
    word-wrap: break-word;

    &:hover {
        color: #343434;
        background-color: #f4f4f4;
    }
`;

